/**
 * Students Page (Users)
 *
 * Standalone full-page users directory. Provides the page chrome —
 * header, padding, layout-config side-effects — and embeds the shared
 * UsersDirectory component for the actual roster + filters + actions.
 *
 * The same UsersDirectory is mounted on the Workspaces edit page's
 * Users tab with `workspaceIdLock` set, scoping the same controls to a
 * single tenant. Keeping the heavy lifting in one component means both
 * surfaces stay feature-for-feature consistent without duplication.
 */

import { useEffect } from 'react';
import { PageHeader } from '../components/common';
import { PersonIcon } from '../components/icons';
import { Box } from '../components/ui';
import { useLayoutConfig } from '../contexts/LayoutContext';
import UsersDirectory from '../components/users/UsersDirectory';

export default function StudentsPage() {
  const { setLayoutConfig } = useLayoutConfig();

  // Hide the topbar's course-scoped global search on this page — it
  // searches the catalog, which has nothing to do with managing users.
  // The page-local "Search by name or email" lives inside the directory.
  useEffect(() => {
    setLayoutConfig({ hideGlobalSearch: true });
    return () => setLayoutConfig({ hideGlobalSearch: false });
  }, [setLayoutConfig]);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'white' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ p: 4 }}>
          <PageHeader
            icon={<PersonIcon />}
            title="Users"
            description="Browse, invite, and manage learners and managers across the account."
          />

          <UsersDirectory />
        </Box>
      </Box>
    </Box>
  );
}
